// extracted by mini-css-extract-plugin
export default {"fullWidth":"ap-z","image":"bp-z","lazyLoadPicture":"cp-z","lazyLoadSpinner":"dp-z","lazyLoadSpin":"ep-z","lazyLoadImage":"fp-z","hasStyledAspectRatio":"gp-z"};